import * as angular from "angular";
import {CparService} from "./cpar.service";

export const CparModule = angular
    .module("app.shared.cpar", [])

    .service("cparService", CparService)

    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/main/client/app/shared/cpar/cpar.module.ts